/* eslint-disable import/no-anonymous-default-export */
const validateSpace = (string) => {
  const validate = string.indexOf(' ') >= 0;
  return validate;
};

export default {
  validateSpace,
};
